export default __webpack_public_path__ + "static/inline-edit-textfield-dont-98f8301b7e916ada051734dad03ca3cc.png";